var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonSkicka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29998"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29997"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29994"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M15.147 1.59 2.68 25.497l8.177-5.305 1.33-7.596 2.2-.008.6-.002-.625-2.783.072 1.682 2.159 1.175 1.254 1.054.335 6.372 8.103 5.81Z",
    "data-name": "Path 35855"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 40732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.948 16.725-.884-1.664 2.864-.135-.183 2.298s.157-2.052-.843-2.069-.954 1.57-.954 1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.064 15.06 2.865-.134-.183 2.296s.157-2.05-.843-2.067c-1-.017-.956 1.57-.956 1.57l-.883-1.664Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonSkicka);
export default __webpack_public_path__ + "static/media/Ikon_Skicka.13ca47e20f75b81c4360d46ef5054c5e.svg";
export { ForwardRef as ReactComponent };